// Libs
import axios from 'axios'
import download from 'downloadjs'
import _ from 'lodash'

// Axios
import { serverAPI } from '../../index'

// Action types
export const CHANGE_CAPTURE_COLUMNS = 'change_capture_columns'
export const CHANGE_CAPTURE_ORDER_BY = 'change_capture_order_by'
export const CHANGE_CAPTURE_FILTERS = 'change_capture_filters'
export const CHANGE_CAPTURE_LAWSUIT_SELECTED = 'change_capture_lawsuit_selected'
export const CHANGE_CAPTURE_LAWSUITS = 'change_capture_lawsuits'
export const CHANGE_CAPTURE_INPUT = 'change_capture_input'
export const CHANGE_CAPTURE_INPUT_LAWYER = 'change_capture_input_lawyer'
export const CHANGE_CAPTURE_FIELD = 'change_capture_input'
export const CHANGE_CAPTURE_LAWYER = 'change_capture_lawyer'
export const CHANGE_CAPTURE_CARD = 'change_capture_card'
export const UPDATE_LAWSUIT = 'update_lawsuit'
export const CHANGE_CAPTURE_LOADING = 'change_capture_loading'
export const CHANGE_CAPTURE_VISIBLE = 'change_capture_visible'
export const CHANGE_CAPTURE_EXPORT_MODEL_SELECTED = 'change_capture_export_model_selected'
export const CHANGE_CAPTURE_CLASSIFIERS = 'change_capture_classifiers'
export const CHANGE_CAPTURE_LAW_FIRMS = 'change_capture_law_firms'
export const CHANGE_CAPTURE_COMPANIES = 'change_capture_companies'
export const CHANGE_SELECTED_LAW_FIRM = 'change_selected_law_firm'
export const CHANGE_SELECTED_COMPANY = 'change_selected_company'
export const CHANGE_CAPTURE_EXPORT_CASES = 'change_capture_export_cases'
export const CHANGE_CAPTURE_TOTAL = 'change_capture_total'
export const CHANGE_CAPTURE_OFFSET = 'change_capture_offset'

// Axios Cancelation
export let fetchLawsuitsCancel
export let fetchLawyerCancel

const captureAPI = axios.create({
  // baseURL: 'https://capture.semprocesso.com.br'
  baseURL: 'http://localhost:3002'
})

export const changeColumns = (columns) => {
  return {
    type: CHANGE_CAPTURE_COLUMNS,
    payload: columns
  }
}

export const changeOrderBy = (value, order) => {
  return {
    type: CHANGE_CAPTURE_ORDER_BY,
    payload: { value, order }
  }
}

export const changeFilters = (filters) => {
  return {
    type: CHANGE_CAPTURE_FILTERS,
    payload: filters
  }
}

export const changeLawsuitSelected = (lawsuitNumber) => {
  return {
    type: CHANGE_CAPTURE_LAWSUIT_SELECTED,
    payload: lawsuitNumber
  }
}

export const changeLawsuits = (lawsuits) => {
  return {
    type: CHANGE_CAPTURE_LAWSUITS,
    payload: lawsuits
  }
}

export const changeInput = (field, value) => {
  return {
    type: CHANGE_CAPTURE_INPUT,
    payload: { field, value }
  }
}

export const changeLawyer = (lawyer) => {
  return {
    type: CHANGE_CAPTURE_LAWYER,
    payload: lawyer
  }
}

export const changeCardType = (card) => {
  return {
    type: CHANGE_CAPTURE_CARD,
    payload: card
  }
}

export const changeField = (form, field, value, options, error) => {
  return {
    type: CHANGE_CAPTURE_FIELD,
    payload: { form, field, value, options, error }
  }
}

export const changeTotal = (total) => {
  return {
    type: CHANGE_CAPTURE_TOTAL,
    payload: total
  }
}

export const changeOffset = (offset) => {
  return {
    type: CHANGE_CAPTURE_OFFSET,
    payload: offset
  }
}

export const changeLoading = (type, loading) => {
  return {
    type: CHANGE_CAPTURE_LOADING,
    payload: { type, loading }
  }
}

export const changeVisible = (type, visible) => {
  return {
    type: CHANGE_CAPTURE_VISIBLE,
    payload: { type, visible }
  }
}

export const changeExportModelSelected = (modelSelected) => {
  return {
    type: CHANGE_CAPTURE_EXPORT_MODEL_SELECTED,
    payload: modelSelected
  }
}

export const changeExportCases = (type) => {
  return {
    type: CHANGE_CAPTURE_EXPORT_CASES,
    payload: type
  }
}

export const saveField = (number, field, value) => {
  return dispatch => {
    captureAPI.post(`/lawsuit/${number}`, { field, value })
      .then(response => {
        dispatch(changeField(0, 'savedAt', new Date()))
        dispatch(updateLawsuit(number))
      })
      .catch(e => {
        console.log(e)
      })
  }
}

export const loadFields = (form, lawsuit) => {
  return dispatch => {
    let lawyerOabNumber = ''
    let lawyerOabUf = ''

    form.map(item => {
      const field = item.field
      let value = ''

      if (field && lawsuit[field]) {
        value = lawsuit[field]
      }

      if (field === 'lawyerOabNumber') {
        lawyerOabNumber = value
      }

      if (field === 'lawyerOabUf') {
        lawyerOabUf = value
      }

      if (item.normalize) {
        value = item.normalize(value.toString())
      }

      dispatch(changeField(0, field, value, null, false))
    })

    dispatch(saveField(lawsuit.number, 'viewed', true))
    dispatch(changeCardType('case'))
    dispatch(changeLawsuitSelected(lawsuit.number))
    dispatch(fetchLawyer(lawyerOabNumber, lawyerOabUf))
  }
}

export const fetchLawyer = (oabNumber, oabUf) => {
  if (fetchLawyerCancel) {
    fetchLawyerCancel()
  }

  let config = {
    cancelToken: new axios.CancelToken(function executor(c) {
      fetchLawyerCancel = c;
    })
  }

  return dispatch => {
    dispatch(changeLawyer({}))

    return serverAPI.get(`/user/lawyer/${oabNumber}/${oabUf}`, config)
      .then(response => {
        const { data } = response

        dispatch(changeLawyer(data))
      })
      .catch(e => {
        console.log(e)
      })
  }
}

export const fetchLawsuits = (filters, _export, lawsuitNumber, total, offset, perPage, action, loading = true) => {
  if (fetchLawyerCancel) {
    fetchLawsuitsCancel()
  }

  let config = {
    cancelToken: new axios.CancelToken(function executor(c) {
      fetchLawsuitsCancel = c;
    })
  }

  return function (dispatch) {
    if (loading) {
      if (_export) dispatch(changeLoading("_export", true))
      else dispatch(changeLoading("page", true))
    }

    const pages = total / perPage
    let newOffset = ''
    let number = ''

    if (lawsuitNumber) {
      number = "/" + lawsuitNumber
    }

    switch (action) {
      case 'first':
        newOffset = 0
        break;
      case 'previous':
        newOffset = offset - perPage
        break;
      case 'next':
        newOffset = offset + perPage > total ? offset : offset + perPage
        break;
      case 'last':
        newOffset = (
          Math.floor(pages) * perPage) === total ?
          (Math.floor(pages) - 1) * perPage :
          Math.floor(pages) * perPage
        break;
      default:
        newOffset = offset
    }

    serverAPI.post('/capture/get-lawsuit' + number, { filters, _export, offset: newOffset, perPage }, config)
      .then(response => {
        const { lawsuits, total, base64 } = response.data

        if (_export) {
          const byteCharacters = atob(base64)
          const byteNumbers = new Array(byteCharacters.length)
          for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i)
          }
          const byteArray = new Uint8Array(byteNumbers)
          const file = new Blob([byteArray], { type: 'application/x-www-form-urlencoded' })

          download(file, 'captacao.xlsx', 'application/x-www-form-urlencoded')
          if (loading) dispatch(changeLoading("_export", false))
          dispatch(changeVisible("_export", false))
        } else {
          dispatch(changeTotal(total))
          dispatch(changeOffset(newOffset))
          dispatch(changeLawsuits(lawsuits))
          if (loading) dispatch(changeLoading("page", false))
        }
      })
      .catch(e => {
        console.log(e)
        if (axios.isCancel(e)) {
          console.log('Request canceled')
        } else {
          if (_export) {
            if (loading) dispatch(changeLoading("_export", false))
            dispatch(changeVisible("_export", false))
          } else {
            if (loading) dispatch(changeLoading("page", false))
          }
        }
      })
  }
}

export const updateLawsuit = (number) => {
  return function (dispatch) {
    captureAPI.post('/lawsuit/' + number)
      .then(response => {
        const { lawsuits } = response.data

        if (!_.isEmpty(lawsuits)) {
          dispatch({
            type: UPDATE_LAWSUIT,
            payload: lawsuits[0]
          })
        }
      })
      .catch(e => {
        console.log(e)
      })
  }
}

export const fetchCaptureLawFirms = () => {
  return dispatch => {
    serverAPI.get('/case/filters')
      .then(response => {
        const { lawFirms, companies } = response.data

        const legalDepartment = { label: 'Departamento Jurídico', value: '' }
        const allLawFirms = [...lawFirms, legalDepartment]

        dispatch(changeField(1, 'company', null, companies, null))
        dispatch(changeField(1, 'lawFirm', null, allLawFirms, null))
        dispatch(changeField(1, 'company', companies[0].value, null, null))
        dispatch(changeField(1, 'lawFirm', allLawFirms[0].value, null, null))
      })
      .catch(_ => {})
  }
}

export const fetchCaptureClassifiers = () => {
  return dispatch => {
    return serverAPI.post('/group/classifier')
      .then(response => {
        let noClassifier = { label: 'Sem classificador', value: [] }
        let classifiers = [...response.data, noClassifier]

        dispatch(changeField(1, 'classifier', null, classifiers, null))
        // dispatch(changeField(1, 'classifier', classifiers[0].value, null, null))
      })
      .catch(_ => {})
  }
}

export const insertCase = (forms) => {
  return dispatch => {
    dispatch(changeLoading("insert", true))

    const dict = {
      number: 'lawsuitNumber',
      uf: 'lawsuitUf',
      lawyerOabNumber: 'oabNumber',
      lawyerOabUf: 'oabUf',
      lawyer: 'lawyerName',
      lawyerEmail: 'lawyerEmail',
      lawyerPhone: 'lawyerPhone',
      plaintiff: 'clientName',
      maxValue: 'maxValue',
      provision: 'provision',
      company: 'companyId',
      lawFirm: 'lawFirmId',
      classifier: 'classifiers',
      message: 'message',
      systemCode: 'ps'
    }

    let newObj = {}

    forms.map(form => {
      form.map(item => {
        if (dict[item.field]) {
          if (item.field === 'classifier') {
            newObj[dict[item.field]] = []

            // if (item.value) {
            //   newObj[dict[item.field]] = [item.value]
            // }
          }
          else {
            newObj[dict[item.field]] = item.value
          }
        }
      })
    })

    return serverAPI.post('case/company', {
      ...newObj,
      lawyerName: newObj.lawyerName.split(' ', 2)[0],
      lawyerSurname: newObj.lawyerName.split(' ', 2)[1]
    })
      .then(response => {
        const { proposal: { id } } = response.data

        dispatch(changeLoading("insert", false))
        dispatch(changeCardType('inserted'))
        dispatch(saveField(newObj.lawsuitNumber, 'capturedStatus', 'Inserido'))
        dispatch(saveField(newObj.lawsuitNumber, 'caseId', id))

        setTimeout(() => {
          dispatch(changeLawsuitSelected(''))
        }, 2000);
      })
      .catch(e => {
        console.log(e)

        dispatch(changeLoading("insert", false))
      })
  }
}

export const validateForm = (form) => {
  return dispatch => {

    const dict = {
      lawyerOabNumber: 'oabNumber',
      lawyerOabUf: 'oabUf',
      lawyer: 'lawyerName',
      lawyerEmail: 'lawyerEmail',
      plaintiff: 'clientName',
      maxValue: 'maxValue',
      systemCode: 'ps'
    }

    let error = false
    form.map(item => {
      if (item.value === '' && dict[item.field]) {
        error = true
        dispatch(changeField(0, item.field, null, null, true))
      }
    })

    console.log(error)

    if (!error) {
      dispatch(changeCardType('insert'))
    }
    else {
      return
    }
  }
}

export const downloadFiles = (number, merged = false) => {
  return dispatch => {
    dispatch(changeLoading("download", true))
    captureAPI.post(`lawsuit/compressFiles/s3/${number}`, { merged })
      .then(response => {
        const interval = setInterval(() => {
          captureAPI.get(`lawsuit/ping/s3File/${number}`)
            .then(response => {
              let { link } = response.data
              if (link) {
                window.open(link, "_blank")
                clearInterval(interval)
                dispatch(changeLoading("download", false))
              }
            })
            .catch(_ => {})
        }, 5000)
      })
      .catch(_ => {})
  }
}
